import { render, staticRenderFns } from "./DetailWebhook.vue?vue&type=template&id=bc0cceb2&"
import script from "./DetailWebhook.vue?vue&type=script&lang=js&"
export * from "./DetailWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports